import React from 'react';
import { Typography, useTheme, useMediaQuery } from '@mui/material';

const ChartTitle = ({ children }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <Typography
            variant="subtitle1"
            sx={{
                textAlign: 'center',
                fontWeight: isMobile ? 'normal' : 'bold',
                fontSize: isMobile ? '1rem' : '1.2rem',
                mb: 1,
                color: 'text.primary',
            }}
        >
            {children}
        </Typography>
    );
};

export default ChartTitle;